import { useEffect, useState } from "react";
import { InputField, MainButton } from "../components";
import { primaryColor, token } from "../constants/constants";
import { fetchUserInfo, updateUserInfo } from "../api/UserInfo";
import VirtualCardShimmer from "../components/VirtualCardShimmer";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "../components";

const MyProfile = () => {
  const [firstName, setFirstName] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [lastName, setLastName] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [user, setUser] = useState();
  const [isVerified, setIsVerified] = useState(false);
  const [successMessage, setSuccessMessage] = useState(""); // To show success message
 const navigate = useNavigate();
  const [debouncedSaveTimer, setDebouncedSaveTimer] = useState(null);

  const getUserInfo = async () => {
    try {
      const info = await fetchUserInfo();
      setUser(info.data);
      setFirstName(info.data.first_name);
      setLastName(info.data.last_name);
      setEmail(info.data.email);
      setPhone(info.data.phone);
      setIsVerified(info.data.is_email_verified === "0" ? false : true);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (!token) {
      return;
    } else {
      getUserInfo();
    }
  }, []);

  // Input field validation
  const validateField = (field, errorSetter, errorMessage) => {
    if (!field) {
      errorSetter(errorMessage);
      return false;
    }
    return true;
  };

  // Save user data immediately
  const saveChangesClicked = () => {
    setIsLoading(true);
    setFirstNameError("");
    setLastNameError("");
    setEmailError("");
    setPhoneError("");

    if (
      !validateField(firstName, setFirstNameError, "The first name field is required") ||
      !validateField(lastName, setLastNameError, "The last name field is required") ||
      !validateField(phone, setPhoneError, "The phone field is required") ||
      !validateField(email, setEmailError, "The email field is required")
    ) {
      setIsLoading(false);
      return;
    }

    if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
      setEmailError("Please enter a valid email");
      setIsLoading(false);
      return;
    }

    const raw = JSON.stringify({
      first_name: firstName,
      last_name: lastName,
      email: email,
      phone: phone,
    });

    updateUserInfo(raw)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === true) {
          setSuccessMessage("Profile saved successfully!"); // Show success message
          setIsLoading(false);
          setTimeout(() => {
            setSuccessMessage(""); // Clear the success message after 3 seconds
          }, 3000);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setIsLoading(false);
      });
  };

  // Using Debouncing to avoid continuous save calls
  const handleInputChange = (e, field) => {
    const value = e.target.value;

    if (field === "phone") {
      // Remove non-numeric characters and enforce max length of 12, add "+" sign at start
      let sanitizedValue = value.replace(/\D/g, "");
      if (sanitizedValue.length <= 12) {
        setPhone("+" + sanitizedValue); // Add the '+' sign
      }
    } else if (field === "firstName") {
      setFirstName(value);
    } else if (field === "lastName") {
      setLastName(value);
    } else if (field === "email") {
      setEmail(value);
    }

    // Debounce saving the profile when user stops typing
    if (debouncedSaveTimer) {
      clearTimeout(debouncedSaveTimer);
    }

    const timer = setTimeout(() => {
      saveChangesClicked();
    }, 1000); // Debounced by 1 second
    setDebouncedSaveTimer(timer);
  };

  return (
    <div className="w-full h-100 flex justify-center items-center bg-slate-10">
      {user !== undefined ? (
        <div className="w-full flex flex-col justify-center items-center">
          <div className="w-[90%] max-w-[600px] text-slate-700 p-2 sm:p-8 shadow-sm rounded-lg bg-white">
          <div className="flex items-center pb-3">
            {/* Back Button */}
            <div 
            onClick={() => navigate('/virtual-cards')}>
              <ArrowLeft className="h-6 w-6 cursor-pointer" />
            </div>
            <div
              className={`text-[${primaryColor}] w-full flex justify-center font-bold text-lg text-center`}
            >
              Profile Setting
            </div>
          </div>
            <hr className="py-2" />
            <div className="py-2">
              <InputField
                label={"First Name"}
                value={firstName}
                onchange={(e) => handleInputChange(e, "firstName")}
                disabled={isVerified}
              />
              <label className="text-red-500 text-sm">{firstNameError}</label>
            </div>
            <div className="py-2">
              <InputField
                label={"Last Name"}
                value={lastName}
                onchange={(e) => handleInputChange(e, "lastName")}
                disabled={isVerified}
              />
              <label className="text-red-500 text-sm">{lastNameError}</label>
            </div>
            <div className="py-2">
              <InputField
                label={"Email"}
                value={email}
                onchange={(e) => handleInputChange(e, "email")}
                type={"email"}
                disabled={isVerified}
              />
              <label className="text-red-500 text-sm">{emailError}</label>
            </div>
            <div className="py-2">
              <InputField
                label={"Phone"}
                value={phone}
                onchange={(e) => handleInputChange(e, "phone")}
              />
              <label className="text-red-500 text-sm">{phoneError}</label>
            </div>
            <br />
            <div className="py-2">
              <MainButton label={"Save Changes"} onClick={saveChangesClicked} isLoading={isLoading} />
            </div>
            {successMessage && (
              <div className="bg-green-200 text-black py-2 px-4 rounded-md mb-4 text-center">
                {successMessage}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="w-full h-screen flex items-center justify-center">
          <VirtualCardShimmer width={500} />
        </div>
      )}
    </div>
  );
};

export default MyProfile;